import { Box, IconButton } from "@mui/material";
import TuneIcon from "@mui/icons-material/Tune";

const DealsFilterIconButton = ({ count = 0, onClick }) => {
  const badgeLabel = count > 9 ? "9+" : String(count);
  const ariaLabel = count > 0 ? `Filters (${count} applied)` : "Filters";

  return (
    <IconButton
      type="button"
      size="small"
      onClick={onClick}
      aria-label={ariaLabel}
      sx={{
        flexShrink: 0,
        p: 0.35,
        color: "#000",
        WebkitTapHighlightColor: "transparent",
        "&:hover": { bgcolor: "rgba(0, 0, 0, 0.06)" },
      }}
    >
      <Box sx={{ position: "relative", display: "inline-flex" }}>
        <TuneIcon sx={{ fontSize: 22, color: "#000" }} />
        {count > 0 ? (
          <Box
            component="span"
            aria-hidden
            sx={{
              position: "absolute",
              top: -5,
              right: -7,
              minWidth: 16,
              height: 16,
              px: count > 9 ? 0.25 : 0,
              borderRadius: "50%",
              bgcolor: "#000",
              color: "#fff",
              fontSize: "0.625rem",
              fontWeight: 700,
              lineHeight: 1,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            {badgeLabel}
          </Box>
        ) : null}
      </Box>
    </IconButton>
  );
};

export default DealsFilterIconButton;
